import { brands } from './registry';
import { isBrandKey, type BrandKey } from './types';

export const BRAND_STORAGE_KEY = 'brand';

// testing aid for stage and local dev; the master env files must never set it
export const brandSwitcherEnabled = import.meta.env.VITE_BRAND_SWITCHER === 'true';

/** the brand picked in the switcher, from `?brand=<key>` or the stored choice */
export function readBrandOverride(): string | null {
  if (!brandSwitcherEnabled) return null;

  try {
    const fromUrl = new URLSearchParams(window.location.search).get('brand');
    if (isBrandKey(fromUrl)) {
      window.localStorage.setItem(BRAND_STORAGE_KEY, fromUrl);
    }

    return window.localStorage.getItem(BRAND_STORAGE_KEY);
  } catch {
    return null;
  }
}

/** reloads the page so every module picks up the new brand */
export function setBrandOverride(key: BrandKey) {
  window.localStorage.setItem(BRAND_STORAGE_KEY, key);
  window.location.reload();
}

export const brandList = Object.values(brands);
